exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-4703342c] {\n  color: green;\n}", ""]);

// exports
